/**
 * @generated SignedSource<<236e49f79574315523d62c284c7ce4b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAbout_item$data = {
  readonly seoDescription: string | null;
  readonly " $fragmentType": "PdpSharedDescriptionAbout_item";
};
export type PdpSharedDescriptionAbout_item$key = {
  readonly " $data"?: PdpSharedDescriptionAbout_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAbout_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAbout_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seoDescription",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3fa5eb653eb5f9f91efcb1b4779365ca";

export default node;
